import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { ErrorAssessmentModal } from '../ErrorAssessmentModal';
import { CompleteAssessmentModal } from '../CompleteAssessmentModal';
import {
  getAssessment,
  postAssessment,
  putAssessment,
} from '../../store/assessmentSingle/actions';
import { IAppState } from '../../store';
import { useHistory } from 'react-router';
import { ROUTES } from '../../config/routes';
import { getApiAssessment } from '../../store/assessment/actions';
import { useTranslation } from 'react-i18next';

interface IProps {
  assessmentsId: any;
  isHaveErrors?: (boolean) => void;
  dataP: any;
  changedFieldsId?: any;
  setChangedFieldsId?: React.Dispatch<React.SetStateAction<any>>;
  setUserHandleSaveData?: React.Dispatch<React.SetStateAction<boolean>>;
  userHandleSaveData: boolean;
}

const CompleteAssessment = ({
  changedFieldsId,
  userHandleSaveData,
  setUserHandleSaveData,
  setChangedFieldsId,
  assessmentsId,
  isHaveErrors,
  dataP,
}: IProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { data } = useSelector((state: IAppState) => state.singleAssessment);
  const originalData = useSelector((state: IAppState) => state.singleAssessment.originalData);
  const assessment = useSelector(
    (state: IAppState) => state.singleAssessment.data,
  ).find(ass => ass.Pages.some(p => p.ID === dataP.ID));
  
  const { Pages = [], ID = 0, StatusFlag = 0 } = assessment || {};
  const { errors, values } = useFormikContext();
  const [buttonClicked, setButtonClicked] = useState(false);
  const [showAgreePopup, setShowAgreePopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const { t, i18n } = useTranslation();

  const handleSaveClick = async (): Promise<void> => {
    const dataToPost = [];
    let objEmpty = [];
    
    if (Pages && Pages.length > 0) {
      Pages.forEach(p =>
        p.Fields.forEach(f => {
          if (f.Template.FieldType.Name === 'Grid') {
            const originalGridField = originalData?.[0]?.Pages?.find(originalPage => 
              originalPage.ID === p.ID
            )?.Fields?.find(originalField => 
              originalField.Template.ID === f.Template.ID
            );
            
            f.GridChildren = f.GridChildren.map((row, rowIndex) => 
              row.map((field, fieldIndex) => {
                const originalRow = originalGridField?.GridChildren?.[rowIndex];
                const originalField = originalRow?.[fieldIndex];
                
                if (originalField && originalField.ID) {
                  return { ...field, ID: originalField.ID };
                }
                
                return { ...field };
              })
            );
            
            if (f.Template.Validator?.MaxRows && f.Template.Validator.MaxRows > f.GridChildren.length) {
              let lastRow = f.GridChildren[f.GridChildren.length - 1];
              if (lastRow) {
                objEmpty = [];
                
                let maxId = 0;
                f.GridChildren.forEach(row => {
                  row.forEach(field => {
                    if (field.ID > maxId) {
                      maxId = field.ID;
                    }
                  });
                });
                
                let newId = maxId + 1;
                
                f.GridChildren[f.GridChildren.length - 1]?.forEach(item => {
                  let newObj = {
                    ...item,
                    ID: newId++,
                    Value: null,
                    GridRow: item.GridRow + 1,
                  };
                  objEmpty.push(newObj);
                });
              }
            }
            f.GridChildren.forEach(fieldsArray => {
              fieldsArray.forEach(field => {
                if (values[f.Guid] && values[f.Guid][field.GridRow] && values[f.Guid][field.GridRow][field.Template.Name] !== undefined) {
                  field.Value = values[f.Guid][field.GridRow][
                    field.Template.Name
                  ] as string | null;
                }
              });
            });
            f.GridChildren.push(objEmpty);
            if (changedFieldsId.includes(f.Guid)) {
              const cleanGridField = {
                ID: f.ID,
                Guid: f.Guid,
                GridRow: f.GridRow,
                GridColumn: f.GridColumn,
                Value: f.Value,
                Template: {
                  ID: f.Template.ID,
                  Name: f.Template.Name,
                  DisplayName: f.Template.DisplayName,
                  Required: f.Template.Required,
                  Order: f.Template.Order,
                  HelpText: f.Template.HelpText,
                  GridChild: f.Template.GridChild,
                  FieldAlias: f.Template.FieldAlias,
                  FieldType_ID: f.Template.FieldType_ID,
                  FieldType: {
                    ID: f.Template.FieldType.ID,
                    Name: f.Template.FieldType.Name,
                    Discriminator: f.Template.FieldType.Discriminator
                  },
                  Parameters_ID: f.Template.Parameters_ID,
                  Parameters: f.Template.Parameters,
                  Validator_ID: f.Template.Validator_ID,
                  Validator: f.Template.Validator,
                  DisplayConditions: f.Template.DisplayConditions,
                  OriginalSize: f.Template.OriginalSize,
                  OriginalWidth: f.Template.OriginalWidth,
                  OriginalHeight: f.Template.OriginalHeight,
                  MaintainAspectRatio: f.Template.MaintainAspectRatio,
                  InitiallyVisibleOnLoad: f.Template.InitiallyVisibleOnLoad,
                  VisibleExternally: f.Template.VisibleExternally,
                  Archived: f.Template.Archived,
                  ImageOnly: f.Template.ImageOnly,
                  HasImage: f.Template.HasImage
                },
                GridChildren: f.GridChildren.map(row => 
                  row.map(field => ({
                    ID: field.ID,
                    Guid: field.Guid,
                    GridRow: field.GridRow,
                    GridColumn: field.GridColumn,
                    Value: field.Value,
                    Template: {
                      ID: field.Template.ID,
                      Name: field.Template.Name,
                      DisplayName: field.Template.DisplayName,
                      Required: field.Template.Required,
                      Order: field.Template.Order,
                      HelpText: field.Template.HelpText,
                      GridChild: field.Template.GridChild,
                      FieldAlias: field.Template.FieldAlias,
                      FieldType_ID: field.Template.FieldType_ID,
                      FieldType: {
                        ID: field.Template.FieldType.ID,
                        Name: field.Template.FieldType.Name,
                        Discriminator: field.Template.FieldType.Discriminator
                      },
                      Parameters_ID: field.Template.Parameters_ID,
                      Parameters: field.Template.Parameters,
                      Validator_ID: field.Template.Validator_ID,
                      Validator: field.Template.Validator,
                      DisplayConditions: field.Template.DisplayConditions,
                      OriginalSize: field.Template.OriginalSize,
                      OriginalWidth: field.Template.OriginalWidth,
                      OriginalHeight: field.Template.OriginalHeight,
                      MaintainAspectRatio: field.Template.MaintainAspectRatio,
                      InitiallyVisibleOnLoad: field.Template.InitiallyVisibleOnLoad,
                      VisibleExternally: field.Template.VisibleExternally,
                      Archived: field.Template.Archived,
                      ImageOnly: field.Template.ImageOnly,
                      HasImage: field.Template.HasImage
                    },
                    GridChildren: field.GridChildren || [],
                    Invalid: field.Invalid
                  }))
                ),
                Invalid: f.Invalid
              };
              
              dataToPost.push(cleanGridField);
            }
          } else {
            if (changedFieldsId.includes(f.Guid)) {
              dataToPost.push({
                ...f,
                Value: values[f.Guid] !== undefined ? values[f.Guid] as string : f.Value,
              });
            }
          }
        }),
      );
    }
    
    try {
      await dispatch(postAssessment(dataToPost, false));
      dispatch(putAssessment(assessmentsId));
      
    } catch (error) {
      console.error('Save error:', error);
    }
  };

  const pagesSet: Set<string> = new Set();
  Object.keys(errors).forEach(key => {
    const assessment = data.find(ass => ass.Pages.some(p => p.Fields.some(f => f.Guid === key)));
    if (assessment) {
      const page = assessment.Pages.find(p => p.Fields.some(f => f.Guid === key));
      if (page) {
        pagesSet.add(page.Template.Name);
      }
    }
  });
  let tabsToFix = Array.from(pagesSet).join(', ');

  const onClick = () => {
    setButtonClicked(true);
    isHaveErrors(true);
  };

  const onExitAgreePopup = () => {
    setShowAgreePopup(false);
    setButtonClicked(false);
  };

  const onExitErrorPopup = () => {
    setShowErrorPopup(false);
    setButtonClicked(false);
  };

  const completeAssessmentHandler = async (): Promise<void> => {
    setButtonClicked(false);
    //await dispatch(putAssessment(assessmentsId));
    setUserHandleSaveData(true);
    try {
      await handleSaveClick();
      await dispatch(getApiAssessment());
      history.push(ROUTES.assessments);
    } catch (error) {
      console.error('Complete assessment error:', error);
    }
  };

  useEffect(() => {
    if (buttonClicked && Object.keys(errors).length) {
      setShowErrorPopup(true);
    } else if (buttonClicked) {
      setShowAgreePopup(true);
    }
    if (Object.keys(errors).length) {
      setShowAgreePopup(false);
    }
  }, [
    buttonClicked,
    errors,
    showAgreePopup,
    setShowErrorPopup,
    setShowAgreePopup,
  ]);

  return (
    <>
      <button
        className="assessment-complete btn action-primary"
        onClick={onClick}
        // onClick={completeAssessmentHandler}
        disabled={StatusFlag === 2 || StatusFlag === 5}
      >
        {t('AP_as_compl')}
      </button>
      <CompleteAssessmentModal
        isOpen={showAgreePopup}
        onComplete={completeAssessmentHandler}
        onExit={onExitAgreePopup}
      />
      <ErrorAssessmentModal
        isOpen={showErrorPopup}
        onExit={onExitErrorPopup}
        text={`${t('AP_tabs')} ${tabsToFix}`}
      />
    </>
  );
};

export { CompleteAssessment };